import { z } from "zod";

export const dayProgramAuditSearchSchema = z.object({
  locationId: z.string().min(1),
  auditDate: z.date(),
});
